import Index from '../views/Release/Index'
import Add from '../views/Release/Add'
import View from '../views/Release/View'

let routes = {
    path: '/projects/:project_id/releases',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '',
            name: 'list-releases',
            component: Index,
        },
        {
            path: 'add',
            name: 'add-release',
            component: Add,
        },
        {
            path: 'edit/:id',
            name: 'edit-release',
            component: Add,
        },
        {
            path: 'view/:id',
            name: 'view-release',
            component: View,
        },
    ],
}

export default routes
